var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 7.38703C6.90204 7.70257 7.20317 7.96366 7.54898 8.15259C7.89478 8.34152 8.27718 8.45387 8.67022 8.48202C9.06326 8.51017 9.45776 8.45346 9.82696 8.31574C10.1962 8.17802 10.5314 7.9625 10.81 7.68382L12.4588 6.03501C12.9594 5.51673 13.2364 4.82258 13.2301 4.10206C13.2239 3.38154 12.9348 2.69231 12.4253 2.1828C11.9158 1.6733 11.2266 1.38429 10.5061 1.37803C9.78557 1.37177 9.09141 1.64876 8.57313 2.14933L7.62782 3.08915",
    stroke: "#A6A6A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93529 7.09908C7.69926 6.78354 7.39813 6.52245 7.05233 6.33352C6.70652 6.14459 6.32413 6.03224 5.93109 6.00409C5.53804 5.97594 5.14354 6.03265 4.77434 6.17037C4.40514 6.3081 4.06988 6.52361 3.7913 6.8023L2.14249 8.4511C1.64192 8.96938 1.36494 9.66353 1.3712 10.3841C1.37746 11.1046 1.66646 11.7938 2.17597 12.3033C2.68547 12.8128 3.3747 13.1018 4.09522 13.1081C4.81574 13.1143 5.50989 12.8374 6.02817 12.3368L6.96799 11.397",
    stroke: "#A6A6A6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link_icon.636b9551ae4cc1a2954c73215dd66887.svg";
export { ForwardRef as ReactComponent };